module.exports = __webpack_public_path__ + "img/heart-2-min.71e1bbe3.jpg";